import { KeyboardEvent, useEffect, useRef, useState } from "react";
import Icon from "../icon/Icon";
import { MAIN_IMAGE_ROOT } from "../../app_config";
import Modal from "../modal/Modal";
import LoadingIndicator from "../loading/LoadingIndicator";

interface ImageViewerProps {
  attachments: ImageViewerItem[];
  onClose: () => void;
  startIndex: number;
}

export interface ImageViewerItem {
  id: string;
  name: string;
  publicUrl: string;
}

const ImageViewer = ({
  attachments,
  onClose,
  startIndex,
}: ImageViewerProps) => {
  const [currentPreviewIndex, setCurrentPreviewIndex] = useState(startIndex);

  const focusRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (startIndex !== undefined && focusRef.current) {
      focusRef.current.focus();
    }
  }, [startIndex]);

  const showPrevious = () => {
    if (!attachments) return;

    let newIndex = 0;

    if (currentPreviewIndex - 1 < 0) {
      newIndex = attachments.length - 1;
    } else {
      newIndex = currentPreviewIndex - 1;
    }

    setCurrentPreviewIndex(newIndex);
  };

  const showNext = () => {
    if (!attachments) return;

    let newIndex = 0;

    if (currentPreviewIndex + 1 === attachments.length) {
      newIndex = 0;
    } else {
      newIndex = currentPreviewIndex + 1;
    }

    setCurrentPreviewIndex(newIndex);
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLDivElement>) => {
    switch (e.key) {
      case "ArrowLeft":
        showPrevious();
        break;
      case "ArrowRight":
        showNext();
        break;
      case "Escape":
        onClose();
        break;
      default:
        break;
    }
  };

  return (
    <Modal
      isOpen={startIndex !== undefined}
      onClose={onClose}
      title={attachments[currentPreviewIndex].name}
    >
      <div
        ref={focusRef}
        tabIndex={0}
        aria-modal="true"
        onKeyDown={handleKeyDown}
        className="relative outline-none"
      >
        {attachments.length > 1 && (
          <>
            <div
              // className="ImageViewer_content_controls-arrow left"
              className="absolute top-[50%] left-0"
              onClick={showPrevious}
            >
              <Icon name="chevron-left" size="big" />
            </div>
            <div
              // className="ImageViewer_content_controls-arrow right"
              className="absolute top-[50%] right-0"
              onClick={showNext}
            >
              <Icon name="chevron-right" size="big" />
            </div>
          </>
        )}
        <div className="flex flex-1 flex-row items-center justify-center">
          <img
            src={`${MAIN_IMAGE_ROOT}${attachments[currentPreviewIndex].publicUrl}`}
            alt={attachments[currentPreviewIndex].name}
            className="max-h-[750px]"
            onLoad={() => <LoadingIndicator />}
          />
        </div>
      </div>
    </Modal>
  );
};

export default ImageViewer;
